import { BrowserRouter } from 'react-router-dom';
import { renderRoutes } from '../routes';
import { useRecordTrail } from '~/hooks/useWayBack';

// Remembers where each screen in this tab's history was, for the back arrows.
function TrailRecorder() {
  useRecordTrail();
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <TrailRecorder />
      {renderRoutes()}
    </BrowserRouter>
  );
}

export default App;
